import { Link, useNavigate } from "react-router-dom";
import { Utilisateure } from "../../Modeles/UtilisateureModel";
import "./connexion.css";
import { useState, useEffect } from "react";
import ScrollReveal from "scrollreveal";
import EnComptePopup from "../../components/EnComptePopup/EnComptePopup";

const Connexion: React.FC<Utilisateure> = ({
  handleSubmit,
  setCompteEmail,
  CompteEmail,
  setPassword,
  Password,
  message,
  commercialsList,
  PopUp,
  name,
  loading,
  enCompteList = [],
  showEnComptePopup = false,
  defaultMagasin = null,
  onSelectEnCompteSupplier,
  onSelectEnCompteDefault,
  onCloseEnCompte,
}) => {
  const navigate = useNavigate();
  const [showPass, setShowPass] = useState(false);
  const [IdCommercial, setIdCommercial] = useState("");
  const [selectedOptionToConnecte, setSelectedOptionToConnecte] = useState<any>(null);
  const [screenWidth, setScreenWidth] = useState<number>(window.innerWidth);
  const [formVisible, setFormVisible] = useState(false);

  /* ── Phone normalizer ─────────────────────────────── */
  const normalizeMoroccanPhone = (value: string): string | null => {
    const cleaned = value.replace(/[\s+-]/g, "");
    if (/^0\d{9}$/.test(cleaned)) return "212" + cleaned.substring(1);
    if (/^212\d{9}$/.test(cleaned)) return cleaned;
    return null;
  };

  /* ── ScrollReveal (desktop only) ─────────────────── */
  useEffect(() => {
    if (screenWidth <= 450) return;
    const sr = ScrollReveal({ distance: "80px", duration: 1600, reset: false });
    sr.reveal(".cx-hero-title",    { delay: 80,  origin: "top"   });
    sr.reveal(".cx-hero-subtitle", { delay: 160, origin: "bottom" });
    sr.reveal(".cx-hero-badge",    { delay: 240, origin: "left"  });
    sr.reveal(".cx-form-title",    { delay: 100, origin: "right" });
    sr.reveal(".cx-form-group",    { delay: 180, origin: "bottom", interval: 80 });
    sr.reveal(".cx-form-links a",  { delay: 300, origin: "bottom", interval: 60 });
    setFormVisible(true);
  }, []);

  /* ── Resize listener ──────────────────────────────── */
  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  /* ── Navigation after store selection ────────────── */
  const handelContinu = (
    idMagasin: any, idCommercial: any, MagasinName: any,
    RemiseGlobal: any, Tele: any, Credit: any, Nom: any
  ) => {
    localStorage.setItem("CommercialId",    idCommercial);
    localStorage.setItem("magasin_connecte", idMagasin);
    localStorage.setItem("MagasinName",     MagasinName);
    localStorage.setItem("remise",          RemiseGlobal);
    localStorage.setItem("Tele",            Tele);
    localStorage.setItem("SoldeCommercial", Credit);
    localStorage.setItem("CommercialName",  Nom);
    navigate(`/commercials/${idCommercial}`);
  };

  /* ── Loader overlay ───────────────────────────────── */
  const WaitingAnimation = () => (
    <div className="cx-loader-overlay">
      <div className="cx-loader-card">
        <div className="cx-spinner" />
        <h2 className="cx-loader-title">Veuillez patienter</h2>
        <p className="cx-loader-text">Connexion en cours…</p>
        <div className="cx-loader-dots">
          <span /><span /><span />
        </div>
      </div>
    </div>
  );

  /* ── Store selection modal ────────────────────────── */
  const StoreModal = () => (
    <div className="cx-modal-overlay">
      <div className="cx-modal">
        <button className="cx-modal-close" aria-label="Fermer">
          <i className="bi bi-x-lg" />
        </button>
        <div className="cx-modal-icon">
          <i className="bi bi-shop" />
        </div>
        <h5 className="cx-modal-title">Choisir votre magasin</h5>
        <p className="cx-modal-subtitle">Vous avez plus d'un magasin</p>
        <div className="cx-store-list">
          {commercialsList.map((item: any, index: number) => (
            <button
              key={item.value || index}
              onClick={() => {
                setSelectedOptionToConnecte(item);
                setIdCommercial(item.IdCommercial);
                handelContinu(
                  item.IdMagasin, item.IdCommercial, item.MagasinName,
                  item.RemiseGlobal || "0", item.Tele || "", item.credit || item.Credit || "0", item.Nom || ""
                );
              }}
              className={`cx-store-option ${
                selectedOptionToConnecte?.IdMagasin === item.IdMagasin ? "cx-store-active" : ""
              }`}
            >
              <div className="cx-store-left">
                <i className="bi bi-building" />
                <span>{item.MagasinName}</span>
              </div>
              {selectedOptionToConnecte?.IdMagasin === item.IdMagasin
                ? <i className="bi bi-check-circle-fill cx-check" />
                : <i className="bi bi-chevron-right cx-arrow" />
              }
            </button>
          ))}
        </div>
      </div>
    </div>
  );

  /* ══════════════════════════════════════════════════
     MOBILE VIEW  (≤ 450px)
  ══════════════════════════════════════════════════ */
  if (screenWidth <= 450) {
    return (
      <div className="cx-mobile">
        <div className="cx-mobile-overlay" />
        <div className="cx-mobile-glow" />

        <div className="cx-mobile-content">
          <div className="cx-mobile-brand">
            <span className="cx-mobile-dot" />
            <h1 className="cx-mobile-title">Wyn.ma</h1>

          </div>
            {name && (<span className="cx-hero-badge">Bienvenu sur l'espace de {name}</span>)}

          <p className="cx-mobile-subtitle">
            Libérer l'efficacité : là où la précision mécanique rencontre le contrôle numérique
          </p>

          <div className="cx-mobile-actions">
            <Link to="/seconnecter" style={{ textDecoration: "none", width: "100%" }}>
              <button className="cx-mobile-btn-primary">
                <i className="bi bi-box-arrow-in-right" />
                Se connecter
              </button>
            </Link>
            <Link to="/visiteurs" style={{ textDecoration: "none", width: "100%" }}>
              <button className="cx-mobile-btn-secondary">
                Rejoindre comme visiteur
                <i className="bi bi-arrow-right" />
              </button>
            </Link>
          </div>

              <Link to="/créer_compte" className="cx-link cx-link-muted">
                <i className="bi bi-plus-circle" />
                Créer votre compte visiteur
              </Link>
              <Link to="/creer-magasin-enligne" className="cx-link cx-link-muted mt-2">
                <i className="bi bi-plus-circle" />
                Créer votre magasin
              </Link>
               <Link to="/mote_de_passe_oublie" className="cx-mobile-forgot  mt-2">
            Mot de passe oublié <i className="bi bi-arrow-repeat" />
          </Link>
        </div>

        {PopUp && <StoreModal />}
        {showEnComptePopup && defaultMagasin && (
          <EnComptePopup
            show={showEnComptePopup}
            magasins={enCompteList}
            defaultMagasin={defaultMagasin}
            onSelectSupplier={onSelectEnCompteSupplier || (() => {})}
            onSelectDefault={onSelectEnCompteDefault || (() => {})}
            onClose={onCloseEnCompte || (() => {})}
          />
        )}
        {loading && <WaitingAnimation />}
      </div>
    );
  }

  /* ══════════════════════════════════════════════════
     DESKTOP VIEW  (> 450px)
  ══════════════════════════════════════════════════ */
  return (
    <>
      <link
        rel="stylesheet"
        href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.1/font/bootstrap-icons.css"
      />

      <div className="cx-container">

        {/* ── Left hero panel ── */}
        <div className="cx-hero">
          <div className="cx-hero-noise" />
          <div className="cx-hero-glow-top" />
          <div className="cx-hero-glow-bottom" />

          <div className="cx-hero-content">
            {name && (<span className="cx-hero-badge">Bienvenu sur l'espace de {name}</span>)}
            <h1 className="cx-hero-title">Wyn<span className="cx-hero-dot">.ma</span></h1>
            <p className="cx-hero-subtitle">
              Libérer l'efficacité : là où la précision mécanique rencontre le contrôle numérique
            </p>
            <div className="cx-hero-line" />
          </div>

          <div className="cx-hero-footer">
            <span>Wyn.ma</span>
          </div>
        </div>

        {/* ── Right form panel ── */}
        <div className="cx-form-panel">
          <div className="cx-form-accent" />

          <form onSubmit={handleSubmit} className="cx-form">

            <div className="cx-form-header">
              <h1 className="cx-form-title">Connexion</h1>
              <div className="cx-form-title-bar" />
            </div>

            {/* Error alert */}
            {message !== "" && (
              <div className="cx-alert">
                <i className="bi bi-exclamation-triangle-fill" />
                <p>{message}</p>
              </div>
            )}

            {/* Email / Phone */}
            <div className="cx-form-group">
              <label className="cx-label">Email ou Téléphone</label>
              <div className="cx-input-wrap">
                <i className="bi bi-person cx-input-icon" />
                <input
                  className="cx-input"
                  type="text"
                  name="CompteEmail"
                  value={CompteEmail}
                  placeholder="Entrez votre email ou téléphone"
                  onChange={(e) => {
                    const val = e.target.value;
                    const phone = normalizeMoroccanPhone(val);
                    setCompteEmail(phone ?? val);
                  }}
                />
              </div>
            </div>

            {/* Password */}
            <div className="cx-form-group">
              <label className="cx-label">Mot de passe</label>
              <div className="cx-input-wrap">
                <i className="bi bi-lock cx-input-icon" />
                <input
                  className="cx-input cx-input-password"
                  type={showPass ? "text" : "password"}
                  name="Password"
                  value={Password}
                  placeholder="Entrez votre mot de passe"
                  onChange={(e) => setPassword(e.target.value)}
                />
                <i
                  className={`bi ${showPass ? "bi-eye-fill" : "bi-eye-slash-fill"} cx-eye`}
                  onClick={() => setShowPass((p) => !p)}
                />
              </div>
            </div>

            <button type="submit" className="cx-submit">
              <span>Entrer</span>
              <i className="bi bi-arrow-right" />
            </button>

            <div className="cx-form-links">
              <Link to="/visiteurs" className="cx-link cx-link-gold">
                <i className="bi bi-people-fill" />
                Rejoindre comme visiteur
              </Link>
                <Link to="/créer_compte" className="cx-link cx-link-muted">
                <i className="bi bi-plus-circle" />
                Créer votre compte visiteur
              </Link>
              <Link to="/mote_de_passe_oublie" className="cx-link">
                <i className="bi bi-arrow-repeat" />
                Mot de passe oublié
              </Link>
              <Link to="/create-magasin" className="cx-link cx-link-muted">
                <i className="bi bi-plus-circle" />
                Créer votre magasin
              </Link>

            </div>
          </form>
        </div>

        {PopUp && <StoreModal />}
        {showEnComptePopup && defaultMagasin && (
          <EnComptePopup
            show={showEnComptePopup}
            magasins={enCompteList}
            defaultMagasin={defaultMagasin}
            onSelectSupplier={onSelectEnCompteSupplier || (() => {})}
            onSelectDefault={onSelectEnCompteDefault || (() => {})}
            onClose={onCloseEnCompte || (() => {})}
          />
        )}
        {loading && <WaitingAnimation />}
      </div>
    </>
  );
};

export default Connexion;